import Component from '../abstracts/Component';

export default class LoginFormComponent extends Component {

  get SELECTORS() {
    return {
        main: '.jsLoginSwitcher',
        activeForms: '.show-form',
    };
  }

  constructor() {
    super();
    this.showForm = 'show-form';
  }
    initSwitcher(){
        let elements = document.querySelectorAll(this.SELECTORS.main);
        for(let el of elements){
            el.addEventListener('click',()=>{
                this.hideForms();
                let formName = el.dataset.targetForm;
                this.switchForm(formName)
            })
        }
        
    }
  
    hideForms(){
        let activeForms = document.querySelectorAll(this.SELECTORS.activeForms);
        for(let activeForm of activeForms){
            activeForm.classList.remove(this.showForm);
            if(activeForm.classList.contains(this.showForm)){
                activeForm.classList.remove(this.showForm);
            }
            return '';
        }
    }
    switchForm(targetForm){
        let form = document.getElementById(targetForm);
        form.classList.add(this.showForm);
    }
    
  render() {
    
    if(document.querySelector(this.SELECTORS.main)){
        this.initSwitcher();
    }

    let myName = this.constructor.name;
    console.log(`[${myName}] Rendering..`);
  }
}
